import { CollectionSlug as CollectionSlugType, CollectionUUID } from '@library/menu-service'

export const CollectionSlug = {
  Recommendations: 'recommendations' as CollectionSlugType,
  AllRecipes: 'all-recipes' as CollectionSlugType,
  DairyFree: 'dairy-free' as CollectionSlugType,
  GlutenFree: 'gluten-free' as CollectionSlugType,
  CalorieControlled: 'calorie-controlled' as CollectionSlugType,
  CarbonCuttingCuisine: 'carbon-cutting-cuisine' as CollectionSlugType,
  SaveSavour: 'save-savour' as CollectionSlugType,
} as const

export const CollectionId = {
  Recommendations: '97270056-cd65-11e8-a2d2-067a72dd5dba' as CollectionUUID,
  AllRecipes: 'ca8f71be-63ac-11e6-a693-068306404bab' as CollectionUUID,
} as const
